import { useState, useCallback } from "react";
import { apiGet, apiPost } from "@/config";

export function useVisitorStats() {
  const [visitorStats, setVisitorStats] = useState({ today: 0, week: 0, total: 0 });
  const [statsError, setStatsError] = useState(null);

  const trackVisit = useCallback(async () => {
    try {
      await apiPost("/track-visit");
    } catch (err) {
      setStatsError(err.message);
    }
  }, []);

  const fetchStats = useCallback(async () => {
    try {
      const { data } = await apiGet("/stats");
      setVisitorStats(data);
      setStatsError(null);
    } catch (err) {
      setStatsError(err.message);
    }
  }, []);

  return { visitorStats, statsError, trackVisit, fetchStats };
}
